'use client';

interface HeroFeaturesLineProps {
  onLoadExample: () => void;
}

export function HeroFeaturesLine({ onLoadExample }: HeroFeaturesLineProps) {
  return (
    <div className="mt-1 flex flex-col items-center gap-1.5 text-[11px] text-zinc-500 sm:mt-4 sm:gap-2 sm:text-sm dark:text-zinc-400">
      {/* Features */}
      <div className="flex items-center gap-1.5 sm:gap-2">
        <span className="whitespace-nowrap">
          Do 15 leków
          <span className="hidden sm:inline"> jednocześnie</span>
        </span>
        <span>•</span>
        <span className="whitespace-nowrap">Codzienna aktualizacja z RPL</span>
        <span>•</span>
        <span className="whitespace-nowrap">
          Cytaty z ChPL<span className="hidden lg:inline"> (rozdział 4.5)</span>
        </span>
      </div>

      {/* Example link pill — hidden on desktop where it's inside the input */}
      <button
        type="button"
        onClick={onLoadExample}
        className="mt-1 cursor-pointer rounded-lg bg-stone-100 px-3.5 py-1.5 text-xs font-medium text-green-600 transition-colors hover:bg-stone-200 hover:text-green-700 sm:hidden dark:bg-stone-800/50 dark:text-green-400 dark:hover:bg-stone-700/50 dark:hover:text-green-300"
      >
        Zobacz przykładową analizę →
      </button>
    </div>
  );
}
